<template>
  <div v-if="isVisible" class="header-banner bg-success">
    <div class="container d-flex justify-content-center align-items-center py-2">
      <div class="text-white h5 mb-0">
        <i class="bi bi-calendar-event me-2"></i>
        <strong>Second Location in Ashburn! We are open for consultation</strong>
      </div>
      <button @click="hide" class="btn-close btn-close-white ms-3" aria-label="Close"></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OpeningAnnouncement',
  data() {
    return {
      isVisible: true
    }
  },
  methods: {
    hide() {
      this.isVisible = false
    }
  }
}
</script>